import React from "react";
// import bannerImage from "../assets/banner.png";
import "../styles/Home.css";

const Banner = () => {
  return (
    <section className="banner">
      <iframe
        width="100%"
        height="640"
        src="https://www.youtube.com/embed/6MObqvoTE68?autoplay=1&loop=1&playlist=6MObqvoTE68"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      {/* <img src={bannerImage} alt="Cat and dog cuddling" className="banner-image" /> */}
    </section>
  );
};

export default Banner;
